import { render, staticRenderFns } from "./feeDetails.vue?vue&type=template&id=00b4ecc2&scoped=true&"
import script from "./feeDetails.vue?vue&type=script&lang=js&"
export * from "./feeDetails.vue?vue&type=script&lang=js&"
import style0 from "./feeDetails.vue?vue&type=style&index=0&id=00b4ecc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b4ecc2",
  null
  
)

export default component.exports